import { render, staticRenderFns } from "./wechat-send-group.vue?vue&type=template&id=48e67a50&scoped=true&"
import script from "./wechat-send-group.vue?vue&type=script&lang=js&"
export * from "./wechat-send-group.vue?vue&type=script&lang=js&"
import style0 from "./wechat-send-group.vue?vue&type=style&index=0&id=48e67a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e67a50",
  null
  
)

export default component.exports